module.exports = "<redirector-page></redirector-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appSettings/redirector.html
// module id = 1900
// module chunks = 0